import React from 'react';
import './Section.css';
import { useLayout } from '../../contexts/layout/LayoutProvider';
import { SectionSettings, As } from './ModularTypes/SectionSettings';
import { SectionClassBuilder } from './builders/SectionClassBuilder';

const Section = ({ children, ...props }: SectionSettings<As>) => {
  const { context } = useLayout();
  const className = SectionClassBuilder.build(props, context.section || {});

  return <section className={`${className}`}>{children}</section>;
};

export default Section;
